/* unplugin-vue-components disabled */import script from "./FeedbackInfoSuccessView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeedbackInfoSuccessView.vue?vue&type=script&setup=true&lang=ts"

import "./FeedbackInfoSuccessView.vue?vue&type=style&index=0&id=15cbfe1c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15cbfe1c"]])

export default __exports__